<template>
    <div :class="[languagesCount >= 4 ?'hidden':'']">
        <select
        :class="['focus:outline-none cursor-pointer',theme.body.backgroundColor, theme.body.textColor]"
        name="languages"
        id="languages"
        @change="changeLanguage($event)"
        >
        <option :selected="language == 'nl'?'selected':''" value="nl" :class="[menu.hasNL||menu.language=='nl'?'':'hidden']">🇳🇱 NL</option>
        <option :selected="language == 'en'?'selected':''" value="en" :class="[menu.hasEN||menu.language=='en'?'':'hidden']">🇬🇧 EN</option>
        <option :selected="language == 'fr'?'selected':''" value="fr" :class="[menu.hasFR||menu.language=='fr'?'':'hidden']">🇫🇷 FR</option>
        <option :selected="language == 'de'?'selected':''" value="de" :class="[menu.hasDE||menu.language=='de'?'':'hidden']">🇩🇪 DE</option>
        </select>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["language", "theme", "menu", "languagesCount"]),
  },
  mounted(){
    if(localStorage.getItem('language')!=null)
    {
      this.$store.commit("changeLanguage", localStorage.getItem('language'));
    }
    else
    {
      this.$store.commit("changeLanguage", this.menu.language);
    }

    if(this.menu.hasDE == false) {
        this.$store.commit("updateLanguagesCount", 1);
    }
    if(this.menu.hasFR == false) {
        this.$store.commit("updateLanguagesCount", 1);
    }
    if(this.menu.hasNL == false) {
        this.$store.commit("updateLanguagesCount", 1);
    }
    if(this.menu.hasEN == false) {
        this.$store.commit("updateLanguagesCount", 1);
    }
   
  },
  methods: {
    /**
     * Change the language.
     *
     * @param language String
     *
     * @returns void
     */
    changeLanguage(event) {
      this.$store.commit("changeLanguage", event.target.value);
    },
  },

};
</script>

